'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

define(['utils/underscore', 'utils/strings'], function (_, strings) {
    var validator = {};

    /**
     * Returns true if the value of the object is null, undefined or the empty
     * string
     *
     * @param a The variable to inspect
     */
    validator.exists = function (item) {
        switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
            case 'string':
                return item.length > 0;
            case 'object':
                return item !== null;
            case 'undefined':
                return false;
        }
        return true;
    };

    /** Determines if the current page is HTTPS **/
    validator.isHTTPS = function () {
        return window.location.href.indexOf('https') === 0;
    };

    /**
     * Determines if a URL is an RTMP link
     */
    validator.isRtmp = function (file, type) {
        return file && (file.indexOf('rtmp') === 0 || type === 'rtmp');
    };

    /**
     * Determines if a URL is an HLS link
     */
    validator.isHls = function (file, type) {
        return file && (strings.extension(file) === 'm3u8' || strings.extension(file) === 'hls' || type === 'hls');
    };

    // 判断是否是flv文件
    validator.isFlv = function (file, type) {
        return file && (strings.extension(file) === 'flv' || type === 'flv');
    };

    // 判断是否是mp4文件
    validator.isMp4 = function (file, type) {
        return file && (strings.extension(file) === 'mp4' || type === 'mp4');
    };

    // 判断是否可用h5播放flv文件
    validator.isHtml5Flv = function (file) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        return validator.isFlv(file, type) && validator.isFlvjsSupported();
    };

    // 判断是否支持flvjs
    validator.isFlvjsSupported = function () {
        return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    };

    // 判断是否是多个m3u8文件
    validator.isMutipleHls = function (sources) {
        if (_.isArray(sources) && sources.length > 1) {
            var hlsLength = 0;
            _.each(sources, function (source) {
                if (validator.isHls(source.file, source.type)) {
                    hlsLength++;
                }
            });
            if (hlsLength === sources.length) {
                return true;
            }
        }
        return false;
    };

    /** Returns the true type of an object * */
    validator.typeOf = function (value) {
        if (value === null) {
            return 'null';
        }
        var typeofString = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        if (typeofString === 'object') {
            if (_.isArray(value)) {
                return 'array';
            }
        }
        return typeofString;
    };

    return validator;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/utils/validator.js
 ** module id = 60
 ** module chunks = 0
 **/